import { Slider, Switch } from 'antd'
import { usePointCloudContext } from 'features/pointClouds'
import {
  ControlItem,
  ControlLabel,
  SliderContainer,
  SliderLabel,
  SliderRow,
  SliderValue,
} from 'pages/pointClouds/components/hud/controlPanel/ControlPanel.styles'
import React from 'react'

export const ClippingSettings: React.FC = () => {
  const {
    nearClippingDistance,
    setNearClippingDistance,
    enableNearClipping,
    setEnableNearClipping,
  } = usePointCloudContext()

  return (
    <>
      <ControlItem>
        <ControlLabel>Enable Near Clipping</ControlLabel>
        <Switch checked={enableNearClipping} onChange={setEnableNearClipping} />
      </ControlItem>

      {enableNearClipping && (
        <SliderRow>
          <SliderLabel>
            Clipping Distance:{' '}
            <SliderValue>{nearClippingDistance.toFixed(2)}m</SliderValue>
          </SliderLabel>
          <SliderContainer>
            <Slider
              value={nearClippingDistance}
              min={0}
              max={50}
              step={0.1}
              onChange={(value) => setNearClippingDistance(value)}
            />
          </SliderContainer>
        </SliderRow>
      )}
    </>
  )
}
